/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {PropertyType} from './property-type';

export class Property {
  id: number;
  property: string;
  name: string;
  group: string;
  type: PropertyType;
  required: boolean;
  readonly: boolean;
  multiple: boolean;
  list: boolean;
  parameter: string;
  format: string;
  order: number;
  hidden: boolean;
  lookAhead: boolean;
  mainDisplay: boolean;
  helpText: string;
  uuid: string;
}
